// extracted by mini-css-extract-plugin
export default {"dropdownList":"DownloadDropdown_dropdownList__Qp1tk","dropdownListItem":"DownloadDropdown_dropdownListItem__h7pzi"};